import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { getQuizQuestions } from 'graphql/queries';
import { Crawler } from './crawler';
import { QuizQuestions, QuizQuestionsVariables } from 'graphql/queries/types/QuizQuestions';
import { useEventContext, useQuizContext } from 'contexts';
import { SharpshooterQuiz } from './sharpshooter-quiz';
import { Spinner } from 'components';
import { SharpshooterSetup } from './sharpshooter-setup';
import { SharpshooterQuizSetup } from './sharpshooter-types';

import './styles/battleship.css';

interface Props {}

enum Scenes {
    Setup,
    Crawler,
    Quiz
}

export const SharpshooterBase = (props: Props) => {
    const [quizSetup, setQuizSetup] = useState<SharpshooterQuizSetup>();
    const [currentScene, setCurrentScene] = useState(Scenes.Setup);

    const eventContext = useEventContext();
    const { quiz } = useQuizContext();

    const {
        loading,
        error,
        data: quizQuestions
        // refetch
    } = useQuery<QuizQuestions, QuizQuestionsVariables>(getQuizQuestions, {
        variables: { quizId: quiz.id! }
    });

    if (loading) return <Spinner />;
    if (error) return <p>Error :(</p>;
    if (!quizQuestions) return <p>No data</p>;

    const onQuizStart = (quizSetup: SharpshooterQuizSetup) => {
        setQuizSetup(quizSetup);
        setCurrentScene(Scenes.Quiz);
    };

    const scenes = {
        [Scenes.Setup]: () => <SharpshooterSetup quizQuestions={quizQuestions} onQuizStart={onQuizStart} />,
        [Scenes.Crawler]: () => <Crawler onClearCrawler={() => setCurrentScene(Scenes.Quiz)} />,
        [Scenes.Quiz]: () => (
            <SharpshooterQuiz
                eventLogo={eventContext?.logo_url}
                gridColumns={quizSetup!.columns}
                gridRows={quizSetup!.rows}
                teams={quizSetup!.teams}
                quizQuestions={quizQuestions}
                isSinglePlayer={quizSetup!.isSinglePlayer}
            />
        )
    };

    return scenes[currentScene]();
};
